import { Component } from "react"
import PropTypes from "prop-types"
import { kebabCase, map } from "lodash"
import classnames from "classnames"
import CellTooltip from "components/securities-table/cell-tooltip"
import { COMPOSITION, filterCompareTable } from "helpers/tables"
import Row from "./row"

export default class CompareTablePanel extends Component {
  static propTypes = {
    columns: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })).isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      fn: PropTypes.func.isRequired,
    })),
    data: PropTypes.array.isRequired,
    fixedItemNumber: PropTypes.bool,
  }

  render() {
    const { items, data, columns, fixedItemNumber } = this.props
    const filteredItems = filterCompareTable(items, data, [
      { key: COMPOSITION.REF_EQUITY, value: "--" },
      { key: COMPOSITION.MODEL_COVERAGE, value: "100.00%" },
    ])
    return <div className={classnames("compare-panel fixed")}>
      {map(filteredItems, ({ label, fn, tooltipContents }, index) => <div key={index} className={classnames("panel-row", { "fixed-item-number": fixedItemNumber })}>
        <div data-test-class={`${kebabCase(label)}-label`} className={classnames("panel-label")}>
          {label}
          {tooltipContents && <CellTooltip contents={tooltipContents} />}
        </div>
        {map(columns, (column, index) => <Row key={index} column={column} data={data} index={index} selector={fn} />)}
      </div>)}
    </div>
  }
}
